module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAABXUlEQVR42u3VO0rEcBTF4ROTMRIcM4P4YsAHPsFCsBorsbEQBAWrKWwGREQQGVAECxsLG0ERxAW4AhdgaeeWjo2prEz+zc09F34LuF9zQBKec/28AAQgAAEIQAACEIAABEAC3XXi+ZJ4u3bRXwCAmGwTN8eOAQAiiYnDbccARWtzxMOZYwCAaGbE+ZFjgKKdTeJl4BgAIDoTxF3fMQBANBKit+sYoGhjiXi8cAwAEK0mMeg5Bija2yJerxwDAMT8DHF/6hgAINJhor/vGOA3QycAAQhAAAIQgAAEIAABCEAA1QHSKOJtNsXv9oqJggJMDyV8H5s183xQgG4j42dr0dTzwQBORsbNPR4EII9iPo12zD5fCWA1TvmRL5h+vjTAQZrzq7Vs/vl/A1ibuKAAFicuGIDViQsCYHniKgHUYeJKA9Rl4koB1GniSgF4TQACEIAABCAAAQhAAAJw2g87ax0ifsgnBQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Kuwait.png
// module id = tnmt
// module chunks = 0 62 63